import { useParams } from "react-router-dom";
import FormActions, {
  SchemaFormAction,
} from "../../components/forms/FormActionNew/FormAction";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import { useCrudAction } from "../../features/api/crud/hooks/useCrudAction";
import styles from "./PageProjectActionCreate.module.scss";
import { useMemo } from "react";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import dayjs from "dayjs";
import {
  useFetchProjectQuery,
  useFetchUsersForFieldQuery,
} from "../../features/api/apiSlice";

const PageProjectActionCreate: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();

  const { onSubmit, isLoading, isPostingAttachments } = useCrudAction(
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "project",
  );

  const { data: project, isFetching: isFetchingProject } = useFetchProjectQuery(
    Number(projectId),
    {
      skip: !projectId,
    },
  );

  const { data: dataPerformers, isFetching: isFetchingPorformers } =
    useFetchUsersForFieldQuery("");

  const defaultValues: SchemaFormAction = useMemo(() => {
    return {
      eventType: "PROJECT",
      dateAsked: dayjs(),
      date: dayjs(),
      causeType: "CORRECTIF",
      title: "",
      description: "",
      effacity: "",
      pilote: "",
      performer: "",
      event: String(projectId),
    };
  }, [projectId]);

  const isPageLoading =
    isLoading || isFetchingProject || isFetchingPorformers || isPostingAttachments;

  return (
    <PageLayout pageContainerClassName={styles.root} isLoading={isPageLoading}>
      <Breadcrumbs
        pageName="newProjectAction"
        eventName={project?.name}
        eventId={Number(projectId)}
      />
      <FormActions
        onSubmit={onSubmit}
        isLoading={isLoading || isPostingAttachments}
        defaultValues={defaultValues}
        performers={dataPerformers || []}
      />
    </PageLayout>
  );
};

export default PageProjectActionCreate;
